/**
 * Common reusable styles for the application
 * Used across Payout, Driver Deduction, and similar modules
 */

// Green outlined button style (used for action buttons like "Download Report", "CREATE PAYOUT")
export const GREEN_BUTTON_STYLE = {
  color: "rgba(57, 181, 74, 1)",
  border: "1px solid rgba(57, 181, 74, 1)",
  borderRadius: "6px",
  backgroundColor: "rgba(225, 244, 228, 1)",
  height: "3.06vw",
  fontSize: "1.11vw",
  padding: "0.69vw 0.97vw",
  textTransform: "none",
  "&:hover": {
    color: "rgba(57, 181, 74, 1)",
    backgroundColor: "rgba(225, 244, 228, 1)",
    borderColor: "#41CC7D",
  },
};

// Green filled button style (used for primary actions like "PROCESS PAYOUT")
export const GREEN_FILLED_BUTTON_STYLE = {
  color: "#FFFFFF",
  backgroundColor: "rgba(57, 181, 74, 1)",
  borderRadius: "6px",
  height: "3.06vw",
  fontSize: "1.11vw",
  padding: "0.69vw 1.5vw",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#41CC7D",
  },
};

// Tab container style with green indicator
export const TABS_STYLE = {
  "& .MuiTabs-flexContainer": {
    display: "flex",
  },
  "& .MuiTabs-indicator": {
    backgroundColor: "rgba(57, 181, 74, 1)",
    height: "3px",
    display: "flex",
    justifyContent: "center",
  },
  "& .MuiTabs-indicatorSpan": {
    maxWidth: "100%",
    width: "100%",
  },
  "& .MuiTab-root.Mui-selected": {
    color: "rgba(57, 181, 74, 1)",
    fontWeight: 600,
  },
};

// Individual tab item style
export const TAB_ITEM_STYLE = {
  textTransform: "none",
  fontSize: "20px",
  minWidth: "auto",
  paddingX: "0",
  marginRight: "24px",
};

// Search field style with rounded corners
export const SEARCH_FIELD_STYLE = {
  minWidth: 150,
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
  },
};

// Status chip styles
export const STATUS_CHIP_STYLES = {
  pending: {
    backgroundColor: "rgba(222, 168, 41, 0.15)",
    color: "#D4A017",
    border: "1px solid #D4A017",
    borderRadius: "6px",
    fontWeight: 500,
    fontSize: "14px",
    height: "32px",
    padding: "0 12px",
    "& .MuiChip-label": {
      padding: "0 8px",
    },
    "& .MuiChip-icon": {
      color: "#D4A017",
      fontSize: "10px",
    },
  },
  approved: {
    backgroundColor: "rgba(222,168,41,0.2)",
    color: "#39B54A",
    border: "1px solid #39B54A",
    borderRadius: "6px",
    fontWeight: 500,
    fontSize: "14px",
    height: "32px",
    padding: "0 12px",
    "& .MuiChip-label": {
      padding: "0 8px",
    },
    "& .MuiChip-icon": {
      color: "#D4A017",
      fontSize: "10px",
    },
  },
  // COMPLETED / success state - green
  active: {
    backgroundColor: "rgba(57, 181, 74, 0.12)",
    color: "#2E7D32",
    border: "1px solid #39B54A",
    borderRadius: "6px",
    fontWeight: 500,
    fontSize: "14px",
    height: "32px",
    padding: "0 12px",
    "& .MuiChip-label": { padding: "0 8px" },
    "& .MuiChip-icon": { color: "#2E7D32", fontSize: "10px" },
  },
  // FAILED state - red
  failed: {
    backgroundColor: "rgba(211, 47, 47, 0.1)",
    color: "#D32F2F",
    border: "1px solid #D32F2F",
    borderRadius: "6px",
    fontWeight: 500,
    fontSize: "14px",
    height: "32px",
    padding: "0 12px",
    "& .MuiChip-label": { padding: "0 8px" },
    "& .MuiChip-icon": { color: "#D32F2F", fontSize: "10px" },
  },
};

// Green text link style (for clickable names)
export const GREEN_LINK_STYLE = {
  color: "#39B54A",
  fontWeight: 600,
  cursor: "pointer",
  "&:hover": {
    textDecoration: "underline",
  },
};

// Modal Cancel button style (outlined green)
export const MODAL_CANCEL_BUTTON_STYLE = {
  color: "#39B54A",
  borderColor: "#39B54A",
  borderRadius: "8px",
  padding: "12px 48px",
  fontSize: "16px",
  fontWeight: 600,
  textTransform: "none",
  minWidth: "180px",
  "&:hover": {
    borderColor: "#39B54A",
    backgroundColor: "rgba(57, 181, 74, 0.04)",
  },
  flex: 1,
};

// Modal Confirm button style (filled green)
export const MODAL_CONFIRM_BUTTON_STYLE = {
  color: "#FFFFFF",
  backgroundColor: "rgba(57, 181, 74, 1)",
  borderRadius: "8px",
  padding: "12px 48px",
  fontSize: "16px",
  fontWeight: 600,
  textTransform: "none",
  minWidth: "180px",
  "&:hover": {
    backgroundColor: "#41CC7D",
  },
  flex: 1,
};
